import { EXPRESS_API } from 'configs/api/expressApi';
import { useMutation, useQueryClient } from 'react-query';
import { VideoTagResponse } from './types';
import { videoTagsKeys } from './videoTagsKeys';
import { useToastError } from 'lib/hooks';
import { useTranslation } from 'react-i18next';

interface ICreateVideoTagBody {
  tag: string;
}

const createTag = async (
  body: ICreateVideoTagBody
): Promise<VideoTagResponse> => {
  return (await EXPRESS_API.post('video-tags', body)).data;
};

export const useCreateTagMutation = () => {
  const queryClient = useQueryClient();
  const { showError } = useToastError();
  const { t } = useTranslation();
  return useMutation(createTag, {
    onSuccess: () => {
      queryClient.invalidateQueries(videoTagsKeys.all());
    },
    onError: e => {
      showError(
        e,
        t('There was a problem creating a new tag. Please try again.')
      );
    },
  });
};
